import React from 'react';

import ReactMixin from 'react-mixin';

import { serializeProperties } from 'serializers/object_serializer';
import { serializePrivateKeys } from 'utils/object_utils';
import { generateUUID } from 'utils/uuid';

export function connectToStore(storeClass, customOptions = {}) {
	const defaultOptions = {
		storeIdProp: 'uniqueStoreItemId',
		storeListener: 'onStoreChange',
		propsForwardToTarget: [],
	};

	return function(Target) {
		const options = Object.assign({}, defaultOptions, customOptions);
		const { storeListener, storeIdProp, propsForwardToTarget } = options;
		const storeInit = options.init || (storeClass.listenables || {}).init;

		const connectedClass = class extends React.Component {
			static propTypes = { ...Target.propTypes };
			static defaultProps = { ...Target.defaultProps };

			constructor(props) {
				super(props);
				const uniqueId = props[storeIdProp] || generateUUID();
				this.state = Object.assign({}, props, { [storeIdProp]: uniqueId });
				if(typeof storeInit === 'function') {
					storeInit(uniqueId, this.state);
				}
			}

			[storeListener](store, itemId, resolve) {
				if(this.state[storeIdProp] === itemId) {
					this.setState(
						serializeProperties(store[itemId]),
						resolve
					);
				}
			}

			componentWillReceiveProps(newProps) {
				const itemId = this.state[storeIdProp];
				const storeItem = storeClass.store[itemId];
				if(!storeItem) return;

				serializePrivateKeys(storeItem)
				.filter(key => newProps.hasOwnProperty(key))
				.forEach(key => storeItem[key] = newProps[key]);

				storeClass.trigger(storeClass.store, itemId);
			}

			buildPropsToForward() {
				var props = { };
				var len = propsForwardToTarget.length;
				while (len--) {
					props[propsForwardToTarget[len]] = this.props[propsForwardToTarget[len]];
				}
				return props;
			}

			render() {
				return <Target {...this.state} {...this.buildPropsToForward()} />;
			}
		};

		try {
			Object.defineProperty(connectedClass, 'name', { configurable: true, value: `${Target.name}Connector` });
		} catch (e) {
			connectedClass.displayName = `${Target.name}Connector`;
		}

		return ReactMixin.onClass(connectedClass, Reflux.listenTo(storeClass, storeListener));
	};
}

export default connectToStore;
